import React, { Component } from 'react'
import { Icon } from '@driftt/tide-core-legacy'
import EventTable from 'components/Integration/components/EventTable'
import { APP_URL } from 'constants/ResourcesConstants'
import { connect } from 'react-redux'
import { nonBotUsers } from 'app/modules/user/selectors'
import './style.styl'

const USER_SOURCE_ID = "drift.user"

class UserLogs extends Component {

  mapUserListToSelectOptions = (users = {}) => {
    return Object.keys(users).map(userId => {
      return {
        value: userId,
        label: users[userId].name || users[userId].email
      }})
  }

  render() {
    const userOptions = this.mapUserListToSelectOptions(this.props.users)

    return (
      <div className="integration-event-log">
        <header>
          <a href={`${APP_URL}/settings2/team`}>
            <Icon
              name="arrow-1-left"
              className="teammate-log-back-arrow"
              width={10}
              height={10} />
            Teammate settings
          </a>
          <h2>Teammate activity log</h2>
          <p>Here you’ll be able to see things like teammates being invited, deleted, and when they go on and offline.</p>
        </header>
        <EventTable
          sourceId={USER_SOURCE_ID}
          hideSeverityFilter
          showTypeFilter
          showReferenceToFilter
          referenceToFilterOptions={[{value: "ALL", label:"All"}, ...userOptions]}
          referenceToFilterName="Team"
        />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  users: nonBotUsers(state).toJS(),
})

export default connect(mapStateToProps, null)(UserLogs)


// WEBPACK FOOTER //
// ./src/scripts/components/settings/team/UserLogs/index.js